<script>
import { isEqual, isNil, get, has, sortBy, take } from 'lodash/fp'
import Toggleable from '@/mixins/toggleable'

export default {
  name: 'FilterList',
  mixins: [Toggleable],
  props: {
    filter: {
      type: Object,
      required: true
    },
    filterIndex: Number,
    value: [Object, String]
  },
  data () {
    return {
      expanded: false,
      loading: false,
      maxItemsToShow: 10
    }
  },
  computed: {
    items () {
      return get('items', this.filter) || []
    },
    filteredItems () {
      return this.items.filter(item => {
        return has('itemText', this.filter)
          ? has(this.filter.itemText, item) && !isNil(get(this.filter.itemText, item))
          : !isNil(item)
      })
    },
    sortedItems () {
      const filter = this.filter
      return filter.itemText
        ? sortBy(item => get(filter.itemText, item).toLowerCase(), this.filteredItems)
        : sortBy(item => item.toLowerCase(), this.filteredItems)
    },
    limitedItems () {
      return take(this.maxItemsToShow)(this.sortedItems)
    }
  },
  methods: {
    listItemClicked (item, index, e) {
      console.log('item: ', item)
      console.log('index: ', index)
      console.log('event: ', event)
      e.stopPropagation()
      e.preventDefault()

      const currentValue = this.value
      console.log('currentValue', currentValue)

      // If the currentvalue is chosen, emit 'null' instead to 'deselect' it
      this.$emit('update', isEqual(currentValue, item) ? null : item)
    },
    showMore () {
      this.maxItemsToShow += 10
    }
  },
  render (h) {
    const listItems = this.limitedItems.map((item, index) => {
      const isSelected = isEqual(this.value, item)
      return (
        <v-list-tile
          onClick={(e) => { this.listItemClicked(item, index, e) }}
          key={item[this.filter.itemValue] || item}
          color={isSelected ? 'primary' : undefined}
        >
          <v-list-tile-action style={{ minWidth: '16px' }}>
            <v-icon v-show={isSelected} color="primary" small>mdi-menu-right</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {item[this.filter.itemText] || item}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      )
    })

    const seeMore = this.limitedItems.length < this.filteredItems.length &&
      (
        <v-list-tile
          color="primary"
          onClick={this.showMore}
        >See More</v-list-tile>
      )

    return (
      <v-list-group
        value={this.expanded}
        lazy
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{this.filter.label}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        {listItems}
        {seeMore}
      </v-list-group>
    )
  }
}
</script>

<style lang="stylus" scoped>
.filter-list
  .filter-list__header
    display: flex
    align-items: center
    user-select: none
    cursor: pointer
    padding:8px 12px

  .filter-list__header:hover
      background-color: rgba(88, 88, 88, .33)

</style>
